<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <code
        class="p-[15px] md:p-[20px] block bg-[#f5f2f0] dark:bg-[#15203c] text-[.875em] break-words text-[#d63384] text-base"
      >
        &lt;<span class="text-[#905] ltr:mr-[5px] rtl:ml-[5px]">i</span
        ><span class="text-[#690]">class</span>=<span class="text-[#07a]"
          >&quot;ri-home-7-line&quot;</span
        >&gt;&lt;/<span class="text-[#905]">i</span>&gt;
      </code>
    </div>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-6 2xl:grid-cols-6 gap-[25px] mb-[25px]"
  >
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-home-7-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-home-7-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-store-2-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-store-2-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-mail-open-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-mail-open-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-cloud-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-cloud-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-bar-chart-box-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-bar-chart-box-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-calendar-todo-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-calendar-todo-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-global-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-global-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-flag-2-fill"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-flag-2-fill
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-service-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-service-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-megaphone-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-megaphone-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-message-2-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-message-2-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-chat-quote-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-chat-quote-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-emoji-sticker-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-emoji-sticker-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-ball-pen-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-ball-pen-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-contrast-2-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-contrast-2-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-collage-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-collage-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-bug-fill"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-bug-fill
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-scan-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-scan-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-wifi-off-fill"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-wifi-off-fill
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-eth-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-eth-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-cup-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-cup-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-cake-3-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-cake-3-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-angularjs-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-angularjs-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-edge-new-fill"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-edge-new-fill
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-xbox-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-xbox-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-map-pin-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-map-pin-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-rocket-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-rocket-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-bus-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-bus-line
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-motorbike-fill"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-motorbike-fill
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center text-[25px]">
        <i class="ri-image-add-line"></i>
        <span class="block mt-[20px] md:mt-[35px] text-base">
          ri-image-add-line
        </span>
      </div>
    </div>
  </div>

  <div class="text-center mb-[25px]">
    <a
      href="https://remixicon.com/"
      target="_blank"
      class="inline-block py-[12px] px-[30px] rounded-full bg-primary-500 text-white transition-all hover:bg-primary-400"
    >
      View All Icons
    </a>
  </div>
</template>

<script>
export default {
  name: "RemixIcon",
};
</script>
